var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"audio-player-icon small-icon print-hidden",class:{
		'is-playing': _vm.isPlaying
	},attrs:{"type":"button","aria-hidden":"true"},on:{"click":function($event){return _vm.onAudioClick()}}},[_c('img',{staticClass:"play",attrs:{"alt":"Audio","src":_vm.audioIconSrc}}),_vm._v(" "),_c('span',{staticClass:"fa-solid fa-circle-pause small-icon pause",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }